import * as LucideIcons from "lucide-react";

function DynamicIcon({ iname, size = 16, color = "currentColor", ...props }) {
  if (!iname) return null;

  const name = String(iname); // ✅ ensures it’s a string

  const key =
    name.charAt(0).toUpperCase() +
    name
      .slice(1)
      .replace(/[-_](\w)/g, (_, c) => c.toUpperCase());

  const LucideIcon = LucideIcons[key];

  if (!LucideIcon) {
    console.warn(`Lucide icon "${iname}" not found.`);
    return null;
  }

  return <LucideIcon size={size} color={color} {...props} />;
}

export default DynamicIcon;